import { useState } from "react";
import { CorperateInfoWidgetStyled, ModalBodyStyled } from "./styled";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { AlertControl } from "components/Modals/Alert";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import { Buttons, Displays, Forms, Icons, Modals } from "components";

// ข้อมูลองค์กร + ปุ่ม Back / Delete / Edit (popup) ใช้ร่วมกันระหว่างหน้า Detail และหน้า View
const CorperateInfoWidget = ({
  data,
  permission,
  title,
  timeline,
  onBack,
  onUpdateSuccess,
  onDeleteSuccess,
}) => {
  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_formValues, _setFormValues] = useState(false);
  const [_deleteTemp, _setDeleteTemp] = useState([]);

  // สร้างสำเนาตอนเปิด popup ครั้งเดียว เพราะฟอร์ม reset ทุกครั้งที่ initialValues เปลี่ยน reference
  const _handleOpenModal = () => {
    _setDeleteTemp([]);
    _setFormValues({ ...data, member_list: [...(data.member_list || [])] });
  };

  const _handleCloseModal = () => {
    _setFormValues(false);
  };

  const _handleDeleteItem = (e) => {
    if (!e.member.isNew) {
      _setDeleteTemp((prev) => [...prev, { ...e, isDelete: true }]);
    }
  };

  const _handleSubmit = async (values) => {
    _setIsBgLoading(true);
    let params = {
      ...values,
      province: values.province.name_th,
      province_en: values.province.name_en,
      province_code: values.province.value,
    };
    params.member_list = (values.member_list || []).map((e) =>
      !e.member.isNew
        ? {
            name: e.member.name,
            member_ref_id: e.member.member_ref_id,
            isNew: e.member.isNew,
          }
        : {
            name: `${e.member.first_name} ${e.member.last_name}`,
            member_ref_id: e.member._id,
            isNew: e.member.isNew,
          }
    );
    _deleteTemp.forEach((e) => {
      params.member_list.push({
        name: e.member.name,
        member_ref_id: e.member.member_ref_id,
        isDelete: e.isDelete,
      });
    });
    let res = await portalService.PUT_ORGANIZATION_UPDATE(data._id, params);
    _setIsBgLoading(false);
    if (res && res.status === 200) {
      toast.success("อัพเดตสำเร็จ");
      _handleCloseModal();
      onUpdateSuccess && onUpdateSuccess();
    } else {
      toast.error("อัพเดตไม่สำเร็จ");
    }
  };

  const _handleDelete = () => {
    AlertControl.show({
      title: "ยืนยันการลบ",
      description: "คุณต้องการจะลบใช่หรือไม่",
      btnLabel1: "ยกเลิก ",
      btnLabel2: "ยืนยัน",
      onEvent2: async () => {
        _setIsBgLoading(true);
        let res = await portalService.DELETE_ORGANIZATION_DETAIL(data._id);
        _setIsBgLoading(false);
        if (res && res.status === 200) {
          toast.success("ลบสำเร็จ");
          onDeleteSuccess && onDeleteSuccess();
        } else {
          toast.error(res?.data?.error?.message || "ลบไม่สำเร็จ");
        }
      },
    });
  };

  return (
    <CorperateInfoWidgetStyled>
      <Displays.BGLoading visible={_isBgLoading} />
      <div className="info_row">
        <div className="info_left_col">
          {title && <div className="title">{title}</div>}
          <Displays.LabelValue
            label="ชื่อองค์กร"
            value={RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: data.name,
            })}
          />
          <Displays.LabelValue
            label="เลขนิติบุคคล"
            value={data.corporate_id || "-"}
          />
          <Displays.LabelValue
            label="เบอร์โทร"
            value={RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: data.phone_number,
              type: "phone",
            })}
          />
          <Displays.LabelValue
            label="อีเมล"
            value={RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: data.email,
            })}
          />
          <Displays.LabelValue label="จังหวัด" value={data.province} />
          {data.member_list &&
            data.member_list.map((e, i) => (
              <Displays.LabelValue
                key={i}
                label={`ชื่อผู้ติดต่อที่ ${i + 1}`}
                value={e.name}
              />
            ))}
        </div>
        {timeline && <div className="info_right_col">{timeline}</div>}
      </div>
      <div className="action_row">
        <div className="w130">
          <Buttons.BgStandard theme_gray label="Back" onClick={onBack} />
        </div>
        {permission && permission.is_delete && (
          <div className="w130">
            <Buttons.BgStandard
              theme_red
              label="Delete"
              onClick={_handleDelete}
            />
          </div>
        )}
        {permission && permission.is_update && (
          <div className="w130">
            <Buttons.BgStandard label="Edit" onClick={_handleOpenModal} />
          </div>
        )}
      </div>
      <Modals.BodyEmpty
        isShowModal={_formValues ? true : false}
        onCloseModal={_handleCloseModal}
      >
        <ModalBodyStyled>
          <div className="btn_close_modal" onClick={_handleCloseModal}>
            <Icons.CloseX />
          </div>
          <div className="modal_title">Corperate / Corperate Detail</div>
          <Forms.CorperateForm
            initialValues={_formValues}
            permission={permission}
            onCancel={_handleCloseModal}
            onDeleteItem={_handleDeleteItem}
            onSubmit={_handleSubmit}
          />
        </ModalBodyStyled>
      </Modals.BodyEmpty>
    </CorperateInfoWidgetStyled>
  );
};

export default CorperateInfoWidget;
